import { render, staticRenderFns } from "./AppSider.vue?vue&type=template&id=4792d611&"
import script from "./AppSider.vue?vue&type=script&lang=js&"
export * from "./AppSider.vue?vue&type=script&lang=js&"
import style0 from "./AppSider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports